import { useEffect, useState } from 'react'
import { Box, Container, Modal, Paper, Skeleton, Stack, Typography } from '@mui/material'
import GoogleMapReact from 'google-map-react'
import { LocationOn, Phone, Email, Language, Public } from '@mui/icons-material'
import './Learning.css'
import EducationalPartnersFilter from './EducationalPartnersFilter'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import SeoEducationalPartners from 'src/components/seo/SeoEducationalPartners'
import { getEducationalPartnersGQL } from 'src/services/graphql/schemas/educationalPartners'

const initialMapConfig = {
  center: {
    lat: 45,
    lng: 15
  },
  zoom: 1
}

const EducationalPartnersMap = () => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const educationalPartners = useSelector((state) => state.educationalPartnersReducer)
  const [open, setOpen] = useState(false)
  const [academy, setAcademy] = useState({})

  useEffect(() => {
    if (!educationalPartners) {
      dispatch(getEducationalPartnersGQL())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [educationalPartners])
  const handleOpen = (newAcademy) => {
    setAcademy(newAcademy)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setAcademy(null)
  }

  const LocationPin = (item, index) => {
    return (
      <div key={item.academyName + index} lat={item.lat} lng={item.lng}>
        <LocationOn className='edu-map-icon' onClick={() => handleOpen(item)} />
      </div>
    )
  }

  const EducationSkeleton = () => {
    return (
      <Container>
        <Stack sx={{ alignItems: 'center', gap: 2 }}>
          <Skeleton variant='text' width={300} sx={{ fontSize: '2rem' }} />
          <Skeleton variant='circular' sx={{ width: { xs: 80, sm: 140 }, height: { xs: 80, sm: 140 } }} />
          <Skeleton variant='rounded' sx={{ width: '100%', height: { xs: 300, sm: 600 } }} />
        </Stack>
      </Container>
    )
  }

  if (!educationalPartners) return <EducationSkeleton />

  return (
    <Container data-cy='educational-partner-container'>
      <SeoEducationalPartners
        title={intl.formatMessage({ id: 'seo.educationalPartners.title' })}
        description={intl.formatMessage({ id: 'seo.educationalPartners.description' })}
      />
      <Typography variant='h2'>
        <FormattedMessage id='learning.educationalPartners' />
      </Typography>
      <Box
        component='img'
        src='https://meteor.stullercloud.com/das/133563794?fmt=smart-alpha'
        alt='Gemvision Educational Partners Logo'
        sx={{ width: { xs: 80, sm: 140 }, py: 3 }}
      />
      <Box sx={{ height: { xs: 300, sm: 600 }, borderRadius: 3, overflow: 'hidden' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyBrYfDnluXjyjkt7fzr060h3-Os6hITaBo' }}
          defaultCenter={initialMapConfig.center}
          defaultZoom={initialMapConfig.zoom}
          yesIWantToUseGoogleMapApiInternals
        >
          {educationalPartners.map((item, index) => {
            return item.lat ? LocationPin(item, index) : null
          })}
        </GoogleMapReact>
      </Box>
      <Modal open={open} onClose={() => handleClose()} className='edu-map-modal'>
        <Paper className='edu-map-paper'>
          <Typography variant='h6' component='h2' gutterBottom>
            {academy?.academyName}
          </Typography>
          <Typography>
            <LocationOn />
            {academy?.location}
          </Typography>
          <Typography>
            <Public />
            {academy?.country}
          </Typography>
          <Typography>
            <Email />
            <a href={'mailto:' + academy?.email}>{academy?.email}</a>
          </Typography>
          <Typography>
            <Phone />
            {academy?.phone}
          </Typography>
          <Typography>
            <Language />
            <a href={academy?.web} target='_blank' rel='noopener noreferrer'>
              {academy?.web}
            </a>
          </Typography>
        </Paper>
      </Modal>
      <EducationalPartnersFilter />
    </Container>
  )
}

export default EducationalPartnersMap
